/* template */
<template><mpx-view @tap="handleClick" class="airflow-train-guide-card" :class='[$attrs["extern-class"],$attrs["externClass"]]'><div :style="[(iconStyle)] | transRpxStyle" class="guide-card-icon"><div :style="[(iconDescStyle)] | transRpxStyle" class="guide-card-icon-text" v-if="(cardIcon)">{{ iconDesc }}</div></div><div class="guide-card-station-info"><div class="station-info">{{ departureStation }}<Icon h="4" w="32" color="#999" name="thin-right-arrow" :externClass='["right-half-arrow-icon"].join(" ")'/>{{ arrivalStation }}</div><div class="time-info"><div class="elapsed-time">{{ formatElapsedTime }}<div class="line"/></div><HlText :text="(personalizedCopy)" color="#666" hlColor="#FF6400" :textStyle="(textStyle)" :externClass='["personalized-copy"].join(" ")'/></div></div><div class="guide-card-price-info"><div class="price-info"><Icon size="32" name="rmb-icon"/><div class="price-text">{{ ticketPrice }}</div></div><div class="purchase-text">{{ purchaseText }}<Icon size="20" name="right-thin-arrow" :externClass='["right-arrow-icon"].join(" ")'/></div></div></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m172f639c"}'>
  .airflow-train-guide-card
    display flex
    justify-content center
    box-sizing border-box
    border-radius 8px
    padding 15px 16px 20px 24px
    background #fff
    .guide-card-icon
      position relative
      width 28px
      height 28px
      background-size 100% 100%
      background-repeat no-repeat
      margin-right 24px
      &-text
        position absolute
        bottom -3px
        left 50%
        line-height 11px
        transform translate(-50%, 100%)
        font-size 11px
        white-space nowrap
        font-family PingFangSC-Medium
        font-weight 500
    .guide-card-station-info
      display flex
      flex-direction column
      overflow hidden
      flex 1
      margin-top 5px
      .station-info
        display flex
        align-items center
        margin-bottom 10px
        font-size 16px
        line-height 1
        color #222
        font-family PingFangSC-Medium
        font-weight 500
        .right-half-arrow-icon
          margin 0 6px
      .time-info
        width 100%
        display flex
        align-items center
        font-size 11px
        line-height 11px
        color #666
        font-family PingFangSC-Regular
        font-weight 400
        .elapsed-time
          position relative
          margin-right 12px
          .line
            position absolute
            top 50%
            right -6px
            width 1px
            height 18px
            background #999
            transform scale(0.5) translateY(-100%)
        .personalized-copy
          font-size 11px
          line-height 1
          display inline-block
          overflow hidden
          white-space nowrap !important
          text-overflow ellipsis
          flex 1
    .guide-card-price-info
      display flex
      flex-direction column
      justify-content space-between
      align-items flex-end
      color #ff6400
      .price-info
        display flex
        align-items flex-end
        .price-text
          font-family Barlow Semi Condensed
          font-size 22px
          line-height 22px
      .purchase-text
        font-size 12px
        line-height 1
        display flex
        align-items center
        .right-arrow-icon
          margin-left 2px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m172f639c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex172f639c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex172f639c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m172f639c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index172f639c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Icon':getComponent(require("../../spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'HlText':getComponent(require("../hl-text/index.mpx?isComponent&outputPath=components%2Findex1ae4dab3%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
